import React from 'react'
import GlobalFunctions from '../../../components/GlobalFunction'

const FunctionPage = () => {
    return (
        <div class="w-full">
            <GlobalFunctions />
        </div>
    )
}

export default FunctionPage
